const features = [
  {
    icon: "https://vibe.filesafe.space/1787327131284421342/assets/39255326-e9a5-4504-840c-9c7cbafbb131.webp",
    title: "FDA-Cleared & fMRI-Guided",
    body: "SAINT® is an FDA-cleared form of TMS that uses fMRI to identify a stimulation target specific to your brain — not standard anatomical landmarks.",
  },
  {
    icon: "https://vibe.filesafe.space/1787327131284421342/assets/bdb9f2f1-5c28-4c96-ba47-ae29a9f6e03d.webp",
    title: "5 Days, Not 6 Weeks",
    body: "Most patients complete SAINT® in one week of consecutive days. Standard TMS runs 5 days a week for 4–6 weeks. SAINT® is a distinct treatment — not just a faster TMS schedule.",
  },
  {
    icon: "https://vibe.filesafe.space/1787327131284421342/assets/f2265d49-9087-4465-9e4b-58fc44d45e25.webp",
    title: "Personalized Brain Targeting",
    body: "Before treatment begins, a resting-state fMRI maps your brain's connectivity so the stimulation target is identified individually — the key difference from one-size-fits-all TMS.",
  },
  {
    icon: "https://vibe.filesafe.space/1787327131284421342/assets/4aa2e8f6-2a50-4034-a11f-f9573bef47f8.webp",
    title: "Non-Invasive, No Sedation",
    body: "You stay awake and alert throughout every session. No anesthesia, no surgery, no systemic side effects. Most people read, listen to music, or rest between sessions.",
  },
];

const TmsTherapy = () => {
  return (
    <section
      id="what-is-saint"
      className="relative bg-gradient-hero py-16 lg:py-28"
    >
      <div className="container-px mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl text-center">
          <div className="mb-4 flex items-center justify-center gap-3">
            <div className="inline-flex items-center rounded-2xl bg-white px-4 py-2 shadow-sm border border-border">
              <img
                src="https://vibe.filesafe.space/1787327131284421342/attachments/861c17b1-d72f-46dc-9f82-4d1ea308284e.png"
                alt="SAINT by Magnus Medical"
                className="h-8 sm:h-9 w-auto object-contain"
                width={180}
                height={45}
                loading="lazy"
              />
            </div>
          </div>
          <span className="text-sm font-semibold uppercase tracking-widest text-accent">
            What Is SAINT® TMS?
          </span>
          <h2 className="mt-3 font-headings text-2xl font-bold text-primary sm:text-3xl md:text-4xl lg:text-[2.75rem]">
            Accelerated, fMRI-guided TMS from Stanford
          </h2>
          <p className="mt-4 text-base text-muted-foreground sm:mt-5 sm:text-lg">
            SAINT® (Stanford Accelerated Intelligent Neuromodulation Therapy) is
            not standard TMS. It is a distinct, FDA-cleared treatment that uses
            proprietary equipment and a proprietary targeting algorithm built on
            science from the Stanford Brain Stimulation Lab. It compresses
            treatment into five consecutive days and uses fMRI to target
            stimulation to your individual brain connectivity — a faster, more
            personalized path for treatment-resistant depression.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:mt-14 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-2xl border border-border bg-card p-7 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-accent/40 hover:shadow-premium"
            >
              <div className="h-1.5 w-10 rounded-full bg-accent" />
              <h3 className="mt-5 font-headings text-lg font-semibold text-primary">
                {f.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">
                {f.body}
              </p>
            </div>
          ))}
        </div>

        {/* Explicit distinction: SAINT® is not standard TMS */}
        <div className="mx-auto mt-10 max-w-3xl rounded-2xl border border-accent/30 bg-accent/[0.04] p-6 sm:p-8 text-center shadow-soft">
          <h3 className="font-headings text-lg font-bold text-primary">
            SAINT® is not the same as standard TMS
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-foreground/80 sm:text-base">
            SAINT® is a one-of-a-kind, FDA-cleared treatment. It combines
            proprietary equipment, a proprietary fMRI-guided targeting
            algorithm, and the science developed at the Stanford Brain
            Stimulation Lab — none of which standard TMS uses. It is delivered
            only by clinics trained and credentialed as Verified SAINT
            Providers, not by any TMS clinic advertising &quot;accelerated
            TMS.&quot;
          </p>
        </div>
      </div>
    </section>
  );
};

export default TmsTherapy;
